import React, {Component, useState} from "react";
import '../../components_style/RegisterForm.css'

import '../../components_style/rtl_css/RegisterForm.css'
import {adminApi} from "../../services/ApiService";

import SvGraphics from "../../assets/SvGraphics";
import DatePicker from "react-datepicker";
import * as XLSX from 'xlsx';

const AdminGenerateRequestHistory = (props) => {

    const [requestID, setRequestID] = useState('');


    const closeSideBar = async () => {
        props.closeSideBar(false)
    }

    const generateReport = async () => {

        let response = await adminApi.generateRequestHistory(requestID)

        if (response && response.data) {
            let changes =response.data.history

            const dataToExport = [
                ['RequestID', 'User Name','Patient_ID','InputName','Old_Value','New_Value','Change_DateTime'],
            ];

            for (let i = 0; i < changes.length; i++) {
                let entryToAdd=[]
                let userPII = changes[i].PII?changes[i].PII:{}

                entryToAdd.push(changes[i].RequestID)
                entryToAdd.push(userPII.First_name + " " + userPII.Last_name)
                entryToAdd.push(changes[i].Patient_ID)
                entryToAdd.push(changes[i].InputName)
                entryToAdd.push(changes[i].Old_Value)
                entryToAdd.push(changes[i].New_Value)
                entryToAdd.push(changes[i].Change_DateTime)

                dataToExport.push(entryToAdd)
            }

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet(dataToExport);
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});

            const blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `requestHistory-${requestID}.xlsx`);
            document.body.appendChild(link);
            link.click();

        }

        props.closeSideBar(false)
    }


    let display = props.isSideBarOpen ? 'block' : 'none'
    let width = props.isSideBarOpen ? "600px" : "0px"
    let container_width = props.isSideBarOpen ? "100%" : "0px"
    const {t} = props

    return (
        <div className={"sidenav-complete"} style={{width: container_width, height: "100%"}}>
            <div className={"sidenav"} style={{width: width, height: "100%", float: 'right'}}>
                <SvGraphics onClick={closeSideBar.bind(this)} className={'close-bar-x'} svgname={'close'}
                            height={'15px'} width={'15px'} style={{
                    float: 'left',
                    top: '10px',
                    left: '10px',
                    position: 'absolute',
                    cursor: 'pointer'
                }}/>
                <div className={'register-form-title container block'}>
                    <h3 className={'h-centered block'}>{props.title}</h3>
                </div>

                <div style={{margin: '20px'}}>
                    <div className={'date-label-block'}>
                        <label className={'date-label'}> {t('hcpLeumitPatientRequests.requestNum')}</label>

                        <input className={'inputBoxStyle'}
                               type="text" name="requestID"
                               onChange={event => setRequestID(event.target.value)}
                               id={"requestID"}
                               value={requestID}/>

                    </div>


                </div>


            </div>
            <div className={'register-form-nav-container block'}>
                <div className={'register-form-nav'}
                     style={{width: width, display: 'flex', justifyContent: "space-around"}}>
                    <button type={"button"} onClick={() => generateReport()} style={{display: display}}
                            className={"btn btn-primary save-info"}>
                        {t('hcpLeumitPatientRequests.generateRequestHistory2')}
                    </button>

                    <button type={"button"} onClick={() => closeSideBar()} style={{display: display}}
                            className={"btn btn-primary save-info"}>
                        {t('admin.hcp.form.close')}
                    </button>
                </div>
            </div>
        </div>
    )


}
export default AdminGenerateRequestHistory;



